import type { TrackData } from '@/domains/shared';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { TrackApi } from '../track-api';

@injectable()
export class TrackApiImpl extends PsHttpService implements TrackApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    track(dataTrack: TrackData) {
        return this.post<PatSnapCommonResponseData<boolean>>({
            url: '/tracking/add',
            data: {
                ...dataTrack,
                module_type: 'EUREKA',
            },
        }).then((res) => {
            return res.status as boolean
        })
    }
}
